import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from 'src/app/screens/gallery/gallery.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { PhotoComponent } from 'src/app/screens/gallery/photo/photo.component';
import { VideoComponent } from 'src/app/screens/gallery/video/video.component';



@NgModule({
  declarations: [
    GalleryComponent,
    PhotoComponent,
    VideoComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'', component:GalleryComponent, children:[
        {path:'photos', component: PhotoComponent},
        {path:'videos', component: VideoComponent},
      ]}
    ])
  ]
})
export class GalleryModule { }
